import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode } from '@gql/graphql'
import {
  CategorieLinkBanner,
  LandingHead,
  Page,
  ProdottiPromozioneSection,
} from 'components/organisms'
import styles from './LandingTemplate.module.sass'
import { PlaceholderReact } from '@components/molecules'
import { JsonLd } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
}

const LandingTemplate = (props: Props) => {
  const { pagina = undefined, mainContent = undefined } = props

  const t = useTrans()

  const headItem = {
    intro: pagina.intro,
    name: pagina.titolo,
    description: pagina.descrizione,
    ctaLabel: pagina.ctaLabel,
    url: pagina.ctaUrl,
  }

  const categorieArgs = {
    item: {
      name: t(`landing_${pagina.pk} categorie_name`),
      description: t(`landing_${pagina.pk} categorie_description`),
      ctaLabel: t(`landing_${pagina.pk} categorie_cta_label`),
      url: t(`landing_${pagina.pk} categorie_url`),
    },
    categorie: pagina.categorie,
    theme: 'secondarydark',
  }

  const categorieProdottiPromozioneArgs = {
    item: {
      name: t(`landing_${pagina.pk} prodotti_name`),
      description: t(`landing_${pagina.pk} prodotti_description`),
    },
    categorie: pagina.categorieLanding,
  }

  return (
    <Page pagina={pagina} item={pagina} className={`${styles.root}`}>
      <main>
        <LandingHead pagina={pagina} item={headItem} />
        <PlaceholderReact
          contentTypeId={pagina.model}
          objectId={pagina.pk}
          pkey={'main'}
          serverSideContent={mainContent}
        />
        <CategorieLinkBanner {...categorieArgs} />
        <ProdottiPromozioneSection {...categorieProdottiPromozioneArgs} />
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default LandingTemplate
